export const POSITIVE_FEEDBACK = 'dm_positive_feedback';
export const NEGATIVE_FEEDBACK = 'dm_negative_feedback';
export const DOM_REASON = 'dm_dom_reason';
export const R_OPPORTUNITY_PRODUCTS = 'dm_r_opportunity_products';
export const DOM_MATCH_STATUS = 'dm_dom_match_status';
export const DOM_SERVICE = 'dm_dom_service';
export const DM_VISITS_COLLECTION = 'items/dm_visits';
export const OPPORTUNITIES = 'dm_opportunities';
